import * as ACTION_TYPES from '../types';

let initialState = {
  materialList: [],
  material: {}
}

export default (state = initialState, action) => {
    switch (action.type) {

    case ACTION_TYPES.ADD_MATERIAL:
      return {materialList: action.data };

      case ACTION_TYPES.GET_MATERIALS:
        return {...state, materialList: action.data };
      
      case ACTION_TYPES.DELETE_MATERIAL:
        let newList = state.materialList.filter(material => material._id !== action.id);
        return {...state, materialList: newList };
      
      case ACTION_TYPES.GET_MATERIAL_BY_ID:
        return {...state, material: action.data};

      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };

      case ACTION_TYPES.DONE:
        return {...state, loading: false };

      case ACTION_TYPES.RESET_MATERIALS:
        return {...state, materialList: []};

      default:
        return state;
    }
  };